var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zt-badge relative m-1 inline-flex max-w-full cursor-default items-center overflow-hidden px-4 align-middle text-sm no-underline outline-none",class:[_vm.shape],style:([_vm.colorStyle])},[_c('span',{staticClass:"zt-badge-text inline-flex items-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }